import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ContextService } from '@app/core/service/context.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer, private contextService: ContextService) {}

  ngOnInit() {
  }

  getImageUrl(imageName: string) {
    const imageUrl = 'assets/images/landingPage/' + imageName;
    return imageUrl;
  }

  isVitafrais() {
    return this.contextService.isVitafrais();
  }
}
